import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

/**
 * Route guard for the marketing pages. Same outcome as UnAuthRoute — a
 * signed-in member is sent to their dashboard — but visitors are rendered
 * immediately instead of waiting behind a spinner for Firebase to resolve
 * the auth state, which would put the hero's first paint behind a network
 * round-trip on every visit.
 */
export default function MarketingRoute({ children }: { children: React.ReactNode }) {
  const { currentUser, loading } = useAuth();
  if (!loading && currentUser) return <Navigate to="/dashboard" replace />;
  return <>{children}</>;
}
